import {
  DTODocumentationPageRoomResponse,
  DTODocumentationStructure,
  DTOPublishDocumentationRequest,
  DTOPublishDocumentationResponse,
} from "../../../dto";
import { DTOGetBlockDefinitionsOutput } from "../../../payloads";
import { RequestExecutor } from "../../../transport/request-executor";

export class DocumentationEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  async getStructure(designSystemId: string, versionId: string) {
    return await this.requestExecutor.json(
      `/design-systems/${designSystemId}/versions/${versionId}/documentation/structure`,
      DTODocumentationStructure
    );
  }

  async getDocStructure(dsId: string, vId: string) {
    return await this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/documentation/structure`,
      DTODocumentationStructure
    );
  }

  async getPageRoom(dsId: string, vId: string, pageId: string) {
    return await this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/documentation/pages/${pageId}/room`,
      DTODocumentationPageRoomResponse
    );
  }

  async getBlockDefinitions(dsId: string, vId: string) {
    return await this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/documentation/block-definitions`,
      DTOGetBlockDefinitionsOutput
    );
  }

  async publish(dsId: string, vId: string, body: DTOPublishDocumentationRequest) {
    return await this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/documentation/publish`,
      DTOPublishDocumentationResponse,
      {
        method: "POST",
        body,
      }
    );
  }
}
